import React, { Component } from "react";
import Select from 'react-select'
import * as tabConst from '../../../utils/TableConstanten'
import { AccordionBody, AccordionHeader, AccordionItem, UncontrolledAccordion } from "reactstrap";
import { GoChevronDown } from "react-icons/go";
import { GoPlus, GoTrash } from "react-icons/go";
import logger from "../../../logging/logger";
import { toast } from "react-toastify";
import { getInitialFirmenId } from "../../../utils/FormHelper";

class FirmenVorsorgeForm extends Component {
 
    constructor(props){
        super(props);
        this.default = {
            editForm: false,
            resourceId: null, 
            firmenSelectOptions: [{ value: 'chocolate', label: 'Chocolate' }],
            vorsorgeSelectOptions: [ { value: 'chocolate', label: 'Chocolate' } ],
            zuordnungSelectOptions: [ { value: 'chocolate', label: 'Chocolate' } ],
            selectedVorsorgeOptions: [],
            selectedZuordnungOptions: [],
            selectedFirmenOptions: [],
            fristenregeln: [],
            data:{
                bg_grundsatz: null,
                anlass: null,
                titel: null, 
                ablaufsfrist: null,
                firmenId: getInitialFirmenId(),
                vorsorgekarteiId: "",
                zuordnungsIds: []
            },
            placeholder:{
                bg_grundsatz: "BG Grundsatz",
                anlass: "Anlass",
                titel: "Titel", 
            }
        };

        this.functions = props.functions

        this.onInputchange = this.onInputchange.bind(this);
        this.handleFirmenSelectChange = this.handleFirmenSelectChange.bind(this);
        this.onVorsorgeChange = this.onVorsorgeChange.bind(this);
        this.onFristenregelChange = this.onFristenregelChange.bind(this);
        this.addFristenregel = this.addFristenregel.bind(this);
        this.removeFristenregel = this.removeFristenregel.bind(this);
        this.onAblaufsfristChange = this.onAblaufsfristChange.bind(this);
        this.state = {...this.default};
    }

    async validate(props) {
        if(props.resourceId){ //Edit Form
            this.setState({
                editForm: true,
                resourceId: props.resourceId
            })
            let firmenkartei = await this.functions.fetchData(props.resourceName+"/"+props.resourceId);
            const firmenId = firmenkartei.firmenId;

            // Wenn ablaufsfrist NULL, hole den Vorsorgekartei-Wert
            let vorsorgeAblaufsfrist = firmenkartei.ablaufsfrist;
            if (!vorsorgeAblaufsfrist && firmenkartei.vorsorgekartei && firmenkartei.vorsorgekartei.ablaufsfrist) {
                vorsorgeAblaufsfrist = firmenkartei.vorsorgekartei.ablaufsfrist;
            }

            this.setState({data: { ...this.state.data, 
                bg_grundsatz: firmenkartei.bg_grundsatz,
                anlass: firmenkartei.anlass,
                titel: firmenkartei.titel,
                ablaufsfrist: vorsorgeAblaufsfrist,
                firmenId: firmenId,
                vorsorgekarteiId: firmenkartei.vorsorgekarteiId,
                zuordnungsIds: await this.getZuordnungsIds(props.resourceId)
            }, fristenregeln: this.parseFristenregeln(firmenkartei.fristenregeln) }, async () => {
                this.setState({ zuordnungSelectOptions: await this.setZuordnungsSelectOptions(firmenId)}, () => {
                    let selected = this.state.zuordnungSelectOptions.filter(option => this.state.data.zuordnungsIds.includes(option.value));
                    this.setState({ selectedZuordnungOptions: selected });
                });
            });
        }

        //firmenSelectOptions         
        this.setState({ firmenSelectOptions: await this.functions.setFirmenSelectOptions()}, () => {
            // Kein Fallback auf erste Firma - wenn keine Firma ausgewählt, bleibt das Feld leer
            this.state.firmenSelectOptions.map(opt => {
                if(opt.value === this.state.data.firmenId){
                    this.setState({ selectedFirmenOption: {value: opt.value, label: opt.label} })
                }
            })
        });

        //Mögliche Vorsorgen ermitteln vorsorgenSelectOptions
        this.setState({ vorsorgeSelectOptions: await this.setVorsorgeSelectOptions()}, () => {
            this.state.vorsorgeSelectOptions.map(option => {
                if(option.value === this.state.data.vorsorgekarteiId){
                    this.setState({selectedVorsorgeOptions: option})
                }
            })
        })

        //tätigkeitsbereiche ermitteln
        if (!props.resourceId) {
            this.setState({ zuordnungSelectOptions: await this.setZuordnungsSelectOptions(this.state.data.firmenId)}, () => {
                let selected = this.state.zuordnungSelectOptions.filter(option => this.state.data.zuordnungsIds.includes(option.value));
                this.setState({ selectedZuordnungOptions: selected });
            });
        }
    }

    parseFristenregeln(fristenregeln) {
        if (!fristenregeln || !Array.isArray(fristenregeln)) return [];
        return fristenregeln.map(regel => ({
            id: regel.id,
            alter_von: regel.alter_von === null ? '' : regel.alter_von,
            alter_bis: regel.alter_bis === null ? '' : regel.alter_bis,
            monate: regel.monate,
            art: regel.art || 'E-/NU'
        }));
    }

    async setZuordnungsSelectOptions(firmenId){
        if (!firmenId) return [];
        let zuordnungen = await this.functions.fetchData(tabConst.ZUORDNUNG, "?firmenId="+firmenId);
        return zuordnungen.data.map((zuordnung) => {
            return {value: zuordnung.id, label: zuordnung.typ + ' - '+zuordnung.bezeichnung}
        })
    }

    async setPlaceholders(){
        let vorsorgeId = this.state.data.vorsorgekarteiId !== 0 ? this.state.data.vorsorgekarteiId : this.state.vorsorgeSelectOptions[0].value
        let vorsorge = await this.functions.fetchData(tabConst.VORSORGEN+'/'+vorsorgeId);
        logger.log('placeholer', vorsorge)
        
        let newData = {
            ...this.state.data,
            bg_grundsatz: vorsorge.bg_grundsatz,
            anlass: vorsorge.anlass,
            titel: vorsorge.titel,
        }
        
        // Wenn ablaufsfrist noch nicht manuell gesetzt wurde, Vorsorgekartei-Wert übernehmen
        if (this.state.data.ablaufsfrist === null || this.state.data.ablaufsfrist === undefined || this.state.data.ablaufsfrist === '') {
            newData.ablaufsfrist = vorsorge.ablaufsfrist;
            logger.log('Ablaufsfrist aus Vorsorgekartei übernommen:', vorsorge.ablaufsfrist);
        }
        
        this.setState({data: newData})
    }

    async setVorsorgeSelectOptions(){
        let vorsorgen = await this.functions.fetchData(tabConst.VORSORGEN);
        return Object.keys(vorsorgen.data).map( (key) => {
            let vorsorge = vorsorgen.data[key]
            let label = vorsorge.bg_grundsatz + 
                        ' ' + vorsorge.anlass + 
                        ' ' + vorsorge.titel;

            return {value: vorsorge.id, label: label}
        })
    }

    async getZuordnungsIds(firmenkarteiId){
        let zuordnungen = await this.functions.fetchData(tabConst.ZUORDNUNG_FIRMENKARTEI, "?firmenkarteiId="+firmenkarteiId);
        let tmp = Object.keys(zuordnungen).map( (key) => {
            let zuordnung = zuordnungen[key];
            return (zuordnung.zuordnungId);
        });
        logger.log('zuordnung', typeof tmp, tmp)
        return tmp
    }

    componentDidMount() {
      this.validate(this.props);
    }
    componentDidUpdate(newProps){
        if(newProps !== this.props){
            this.setState({...this.default}, ()=> this.validate(newProps))
        }
    }

    async handleFirmenSelectChange(e){
        this.setState({
            selectedFirmenOption: e,
            data: {...this.state.data, firmenId: e.value, zuordnungsIds: []},
            selectedZuordnungOptions: [],
            zuordnungSelectOptions: await this.setZuordnungsSelectOptions(e.value)
        });
    }

    onVorsorgeChange(selectedOption){
        logger.log(selectedOption)
        this.setState({data: {...this.state.data, vorsorgekarteiId: selectedOption.value  }}, () => {
            this.setPlaceholders();
        })
        this.setState({selectedVorsorgeOptions: selectedOption})
    }

    onAblaufsfristChange(e) {
        const value = e.target.value === '' ? null : parseInt(e.target.value, 10);
        this.setState({data: {...this.state.data, ablaufsfrist: value}});
    }

    onFristenregelChange(index, field, value) {
        const newRegeln = [...this.state.fristenregeln];
        let parsedValue = value;
        
        // Nur numerische Felder parsen, art bleibt String
        if (field === 'monate' || field === 'alter_von' || field === 'alter_bis') {
            parsedValue = value === '' ? null : parseInt(value, 10);
            if (isNaN(parsedValue)) parsedValue = null;
        }
        
        newRegeln[index] = {
            ...newRegeln[index],
            [field]: parsedValue
        };
        
        this.setState({ fristenregeln: newRegeln });
    }

    // Validierung der Altersabhängigen Fristenregeln
    validateFristenregeln() {
        const { fristenregeln } = this.state;
        
        // Wenn keine Regeln vorhanden sind, ist das OK
        if (!fristenregeln || fristenregeln.length === 0) {
            return { valid: true };
        }
        
        for (let i = 0; i < fristenregeln.length; i++) {
            const regel = fristenregeln[i];
            
            // Prüfung 1: Monate müssen vorhanden sein
            if (regel.monate === null || regel.monate === undefined || regel.monate === '') {
                return {
                    valid: false,
                    message: `Fristenregel ${i + 1}: Bitte geben Sie die Monate an.`
                };
            }
            
            // Prüfung 2: Mindestens ein Alter muss definiert sein
            const alterVonLeer = regel.alter_von === null || regel.alter_von === undefined || regel.alter_von === '';
            const alterBisLeer = regel.alter_bis === null || regel.alter_bis === undefined || regel.alter_bis === '';
            
            if (alterVonLeer && alterBisLeer) {
                return {
                    valid: false,
                    message: `Fristenregel ${i + 1}: Bitte geben Sie mindestens ein Alter an (von oder bis).`
                };
            }
            
            // Prüfung 3: alter_von darf nicht größer als alter_bis sein
            if (!alterVonLeer && !alterBisLeer && regel.alter_von > regel.alter_bis) {
                return {
                    valid: false,
                    message: `Fristenregel ${i + 1}: Alter 'von' (${regel.alter_von}) darf nicht größer als 'bis' (${regel.alter_bis}) sein.`
                };
            }
        }
        
        return { valid: true };
    }

    addFristenregel() {
        this.setState({
            fristenregeln: [
                ...this.state.fristenregeln,
                { alter_von: '', alter_bis: '', monate: '', art: 'E-/NU' }
            ]
        });
    }

    removeFristenregel(index) {
        const newRegeln = this.state.fristenregeln.filter((_, i) => i !== index);
        this.setState({ fristenregeln: newRegeln });
    }

    onInputchange(event){
        if(Array.isArray(event)){ //wenn array dann selectBox Zuordnungen
            let zuordnungId = Array.from(event, option => option.value);
            logger.log('inpChan', 'zuordnungsIds', zuordnungId )
            this.setState({ data: {...this.state.data, zuordnungsIds: zuordnungId }})
            this.setState({selectedZuordnungOptions: event })
        }else {
            this.setState({data: {...this.state.data, [event.target.name]: event.target.value  }});
            logger.log('inpChan', event.target.name, event.target.value )
        }
    }

    put_post_fetch(method, url){
        logger.log('save this:', method ,this.state.data)
        let req = {
            method: method,
            headers: {
              'Content-Type': 'application/json',
              'Authorization': global.auth.authToken.token 
            },
            body: JSON.stringify({
                ...this.state.data,
                fristenregeln: this.state.fristenregeln
            })
        };
        return fetch(url, req)
          .then(res => res.json())
          .then(response => {
            let data = response.data ? response.data: response;

            //Wenn Angelegt, passen wir noch die Zuordnungen an
            let firmenkarteiId = data.id ? data.id : this.props.resourceId;
            if(firmenkarteiId !== undefined && this.state.data.zuordnungsIds){
                this.functions.fetchData(tabConst.ZUORDNUNG_FIRMENKARTEI, "?firmenkarteiId="+firmenkarteiId).then(data => {
                    let zuordnungsKeys = Object.keys(data).map((key) => {
                        if(!this.state.data.zuordnungsIds.includes(data[key].zuordnungId)){
                            logger.log('test wegenehmen', data[key].zuordnungId)
                            fetch(global.api_url + tabConst.ZUORDNUNG_FIRMENKARTEI, {
                                method: 'DELETE',
                                headers: req.headers,
                                body: JSON.stringify({
                                    firmenkarteiId: firmenkarteiId,
                                    zuordnungId: data[key].zuordnungId
                                })
                            });
                        }
                        return data[key].zuordnungId;
                    })
                    this.state.data.zuordnungsIds.map(id => {
                        if(!zuordnungsKeys.includes(id)){
                            logger.log('test hinzufügen', id)
                            fetch(global.api_url + tabConst.ZUORDNUNG_FIRMENKARTEI, {
                                method: 'POST',
                                headers: req.headers,
                                body: JSON.stringify({
                                    firmenkarteiId: firmenkarteiId,
                                    zuordnungId: id
                                })
                            });
                        }
                    })
                    return true;
                });
            }else {
                logger.error("kein Zuordnung?!")
            }
          });
    }

    saveOrUpdate(){
        // Validierung der Fristenregeln vor dem Speichern
        const validation = this.validateFristenregeln();
        if (!validation.valid) {
            toast.error(validation.message);
            return Promise.reject(new Error(validation.message));
        }
        
        if(this.state.editForm){
            return this.put_post_fetch("PUT", global.api_url + tabConst.FIRMENKARTEI+'/'+this.state.resourceId);
        }else{
            return this.put_post_fetch("POST",  global.api_url + tabConst.FIRMENKARTEI);
        }
    }

    renderFristenregelnTabelle() {
        const { viewOnly } = this.props;
        
        return (
            <div className="fristenregeln-tabelle">
                <table className="table table-sm">
                    <thead>
                        <tr>
                            <th>Art</th>
                            <th>Prüfung Alter</th>
                            <th>Monate</th>
                            {!this.props.viewOnly && <th></th>}
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.fristenregeln.map((regel, index) => {
                            let alterLabel = 'Standard';
                            if (regel.alter_von !== null && regel.alter_von !== '' && regel.alter_bis !== null && regel.alter_bis !== '') {
                                alterLabel = `${regel.alter_von}-${regel.alter_bis}`;
                            } else if (regel.alter_von !== null && regel.alter_von !== '') {
                                alterLabel = `>${regel.alter_von}`;
                            } else if (regel.alter_bis !== null && regel.alter_bis !== '') {
                                alterLabel = `<${regel.alter_bis}`;
                            }
                            
                            return (
                                <tr key={index}>
                                    <td>
                                        {!this.props.viewOnly ? (
                                            <select 
                                                className="form-control form-control-sm"
                                                value={regel.art || 'E-/NU'}
                                                onChange={(e) => this.onFristenregelChange(index, 'art', e.target.value)}
                                                style={{width: '90px'}}
                                            >
                                                <option value="E-/NU">E-/NU</option>
                                                <option value="EU">EU</option>
                                                <option value="NU">NU</option>
                                            </select>
                                        ) : (
                                            <span>{regel.art || 'E-/NU'}</span>
                                        )}
                                    </td>
                                    <td>
                                        {!this.props.viewOnly ? (
                                            <div className="d-flex gap-2">
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-sm" 
                                                    placeholder="von"
                                                    value={regel.alter_von === null || regel.alter_von === '' ? '' : regel.alter_von}
                                                    onChange={(e) => this.onFristenregelChange(index, 'alter_von', e.target.value)}
                                                    style={{width: '70px'}}
                                                />
                                                <span className="align-self-center">-</span>
                                                <input 
                                                    type="number" 
                                                    className="form-control form-control-sm" 
                                                    placeholder="bis"
                                                    value={regel.alter_bis === null || regel.alter_bis === '' ? '' : regel.alter_bis}
                                                    onChange={(e) => this.onFristenregelChange(index, 'alter_bis', e.target.value)}
                                                    style={{width: '70px'}}
                                                />
                                            </div>
                                        ) : (
                                            <span>{alterLabel}</span>
                                        )}
                                    </td>
                                    <td>
                                        {!this.props.viewOnly ? (
                                            <input 
                                                type="number" 
                                                className="form-control form-control-sm" 
                                                value={regel.monate === '' ? '' : regel.monate}
                                                onChange={(e) => this.onFristenregelChange(index, 'monate', e.target.value)}
                                                style={{width: '80px'}}
                                            />
                                        ) : (
                                            <span>{regel.monate}</span>
                                        )}
                                    </td>
                                    {!this.props.viewOnly && (
                                        <td>
                                            <button 
                                                type="button" 
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => this.removeFristenregel(index)}
                                            >
                                                <GoTrash />
                                            </button>
                                        </td>
                                    )}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                {!this.props.viewOnly && (
                    <button 
                        type="button" 
                        className="btn btn-sm btn-outline-primary"
                        onClick={this.addFristenregel}
                    >
                        <GoPlus /> Zeile hinzufügen
                    </button>
                )}
            </div>
        );
    }

    render(){
        return (
        <form>
            <UncontrolledAccordion stayOpen defaultOpen={["1", "2", "3", "4"]}>
                <AccordionItem>
                  <AccordionHeader targetId="1">Firma <i className="icon"><GoChevronDown /></i></AccordionHeader>
                  <AccordionBody accordionId="1">
                  <div className="form-group">
                      <label htmlFor="firmen" className="control-label">Firma</label>
                      <Select 
                      placeholder = "Auswählen"
                      options={ this.state.firmenSelectOptions} 
                      value= { this.state.selectedFirmenOption }
                      name="firmenId"
                      className="basic-multi-select"
                      isDisabled={this.props.viewOnly}
                      onChange={ this.handleFirmenSelectChange }
                      theme={theme => ({
                          ...theme,
                          colors: {
                          ...theme.colors,
                          primary25: '#ffeebe',
                          primary: '#ffd370',
                          },
                      })}
                      />
                  </div>
                  </AccordionBody>
                </AccordionItem>
                
                {/* Vorsorgen */}
                <AccordionItem>
                  <AccordionHeader targetId="2">Vorsorge <i className="icon"><GoChevronDown /></i></AccordionHeader>
                  <AccordionBody accordionId="2">
                    <div className="form-group">
                        <label htmlFor="" className="control-label">Verbundene Vorsorge</label> 
                        <Select 
                            placeholder = "Auswählen"
                            options={ this.state.vorsorgeSelectOptions } 
                            value={ this.state.selectedVorsorgeOptions }
                            name="vorsorgekarteiId"
                            className="basic-multi-select"
                            isDisabled={this.props.viewOnly}
                            onChange={ this.onVorsorgeChange }
                            theme={theme => ({
                                ...theme,
                                colors: {
                                ...theme.colors,
                                primary25: '#ffeebe',
                                primary: '#ffd370',
                                },
                            })}
                        />
                    </div>
                    {/* BG Grundsatz */}
                    <div className="form-group">
                        <label htmlFor="bg_grundsatz" className="control-label">BG Grundsatz</label> 
                        <input type="text" id="bg_grundsatz" name="bg_grundsatz" className="form-control" placeholder={ this.state.placeholder.bg_grundsatz }
                                value={this.state.data.bg_grundsatz || ''} onChange={this.onInputchange} disabled={this.props.viewOnly} />
                    </div>
                    {/* Anlass */}
                    <div className="form-group">
                        <label htmlFor="anlass" className="control-label">Anlass</label> 
                        <input type="text" id="anlass" name="anlass" className="form-control" placeholder={ this.state.placeholder.anlass }
                                value={this.state.data.anlass || ''} onChange={this.onInputchange} disabled={this.props.viewOnly} />
                    </div>
                    {/* Titel */}
                    <div className="form-group">
                        <label htmlFor="titel" className="control-label">Titel</label> 
                        <input type="text" id="titel" name="titel" className="form-control" placeholder={ this.state.placeholder.titel }
                                value={this.state.data.titel || ''} onChange={this.onInputchange} disabled={this.props.viewOnly} />
                    </div>
                  </AccordionBody>
                </AccordionItem>

                {/* Ablauf Regeln */}
                <AccordionItem>
                  <AccordionHeader targetId="3">Ablauf Regeln <i className="icon"><GoChevronDown /></i></AccordionHeader>
                  <AccordionBody accordionId="3">
                    {/* Standard Ablaufsfrist */}
                    <div className="form-group">
                        <label htmlFor="ablaufsfrist" className="control-label">Standard Ablaufsfrist (Monate)</label>
                        <input 
                            type="number" 
                            id="ablaufsfrist" 
                            name="ablaufsfrist" 
                            className="form-control" 
                            placeholder="z.B. 36"
                            value={this.state.data.ablaufsfrist === null ? '' : this.state.data.ablaufsfrist}
                            onChange={this.onAblaufsfristChange}
                            disabled={this.props.viewOnly}
                            style={{width: '150px'}}
                        />
                        <small className="form-text text-muted">
                            Wird verwendet, wenn keine altersabhängige Regel passt.
                        </small>
                    </div>
                    
                    {/* Altersabhängige Regeln */}
                    <div className="form-group">
                        <label className="control-label">Altersabhängige Fristenregeln</label>
                        {this.renderFristenregelnTabelle()}
                        <small className="form-text text-muted">
                            Leer lassen für Standard-Frist. Regeln werden in Reihenfolge geprüft.
                        </small>
                    </div>
                  </AccordionBody>
                </AccordionItem>
                
                {/* Tätigkeitsbereiche */}
                <AccordionItem>
                  <AccordionHeader targetId="4">Tätigkeit/Bereich <i className="icon"><GoChevronDown /></i></AccordionHeader>
                  <AccordionBody accordionId="4">
                    <div className="form-group">
                        <label htmlFor="" className="control-label">Verbundene Tätigkeitsbereiche</label> 
                        <Select 
                            isDisabled = { this.state.zuordnungSelectOptions.length === 0 || this.props.viewOnly }
                            placeholder = { (this.state.zuordnungSelectOptions.length === 0)? "Keine Tätigkeitsbereiche für die Firma definiert": "Auswählen"}
                            options={ this.state.zuordnungSelectOptions } 
                            value={ this.state.selectedZuordnungOptions }
                            isMulti
                            name="zuordnungsIds"
                            className="basic-multi-select"
                            onChange={ this.onInputchange }
                            theme={theme => ({
                                ...theme,
                                colors: {
                                ...theme.colors,
                                primary25: '#ffeebe',
                                primary: '#ffd370',
                                },
                            })}
                        />
                    </div>
                  </AccordionBody>
                </AccordionItem>
        </UncontrolledAccordion>
        </form>
        );
    }
}
export default FirmenVorsorgeForm;